/**
 * CMP
 * @link https://cookie-script.com/
 */
import {
  getCmpActiveGroups,
  isArray,
  runMethodWhenCmpApiIsReady
} from '@/plugins/helper'
import { REQUIRED_COOKIE_CATEGORIES_BY_COOKIE_ENTITY_TYPE } from 'enums/cmp'
import { CMP_STATE } from '../enums/cmp'

export function toggleCookiePreferencesPopup() {
  runMethodWhenCmpApiIsReady(window.CookieScript.instance.showDetails)
}

function isConsentGivenForGroups(groupIds = []) {
  if (process.server) return false

  return groupIds.every(groupId => getCmpActiveGroups().includes(groupId))
}

/**
 * Checks if prior blocking of a specific entity is required
 *
 * (!) Important note: for legal purposes,  we block every script/iframe
 * in case the site is being previewed from FM. In case when site is being
 * previewed from BO, we don't block anything.
 * @param entity
 */
export function isConsentGivenForEntity(entity) {
  if (!entity) return false

  const requiredGroups =
    REQUIRED_COOKIE_CATEGORIES_BY_COOKIE_ENTITY_TYPE[entity]

  if (!requiredGroups || !isArray(requiredGroups)) return true

  return isConsentGivenForGroups(requiredGroups)
}

export function isCalifornia() {
  if (process.server) return false

  try {
    const geoTargeting = window.CookieScript.instance.getGeoTargeting()
    return (
      geoTargeting &&
      Array.isArray(geoTargeting.state) &&
      geoTargeting.state.includes(CMP_STATE.CA)
    )
  } catch {
    return false
  }
}

export default {
  methods: {
    $_cmp_isConsentGivenForEntity: isConsentGivenForEntity,
    $_cmp_toggleCookiePreferencesPopup: toggleCookiePreferencesPopup,
    $_cmp_isCalifornia: isCalifornia
  }
}
